import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

export const DisclaimerBanner = () => {
  // Dismissal lasts for the current visit only, so the risk warning is shown
  // again on every new session rather than disappearing forever.
  const [isDismissed, setIsDismissed] = useState(() => {
    return sessionStorage.getItem('disclaimer-dismissed') === 'true';
  });

  const handleDismiss = () => {
    sessionStorage.setItem('disclaimer-dismissed', 'true');
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <div className="relative z-30 bg-warning/10 border-b border-warning/30">
      <div className="container mx-auto px-4 py-2">

        <Alert className="bg-transparent border-0 p-0">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-warning mt-0.5 flex-shrink-0" />
            <AlertDescription className="flex-1 text-sm text-foreground">
              <strong className="font-semibold">Important:</strong> General information only —
              not personalised financial advice. Crypto is volatile and you can lose your entire
              investment.{' '}
              <Link to="/disclaimer" className="underline underline-offset-2 font-medium">
                Read the full disclaimer
              </Link>
              .
            </AlertDescription>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDismiss}
              className="flex-shrink-0 text-muted-foreground hover:text-foreground"
            >
              Got it
            </Button>
          </div>
        </Alert>
      </div>
    </div>
  );
};
